import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { ApiNurseCallService } from './api-call-providers/api-nurse-call.service';
import { DataCacheService } from './data-cache.service';
import { Observable } from 'rxjs';
import { ApiRoomService } from './api-call-providers/api-room.service';


@Injectable()
export class NurseCallService {

  // 初期ロード
  private initSource = new Subject<any>();
  init$ = this.initSource.asObservable();

  // 機器情報一覧取得
  private loadSource = new Subject<any>();
  loadList$ = this.loadSource.asObservable();

  // 初期設定済みかどうか
  isInitialized: boolean = true;

  private callRoomListSource = new Subject<any>();
  callRoomList$ = this.callRoomListSource.asObservable();

  // ナースコール部屋情報作成
  private createSource = new Subject<any>();
  create$ = this.createSource.asObservable();

  // ナースコール一括作成
  private createAllSource = new Subject<any>();
  createAll$ = this.createAllSource.asObservable();

  // ナースコール部屋情報をまるっとセット
  private updateAllSource = new Subject<any>();
  updateAll$ = this.updateAllSource.asObservable();

  // ナースコール部屋情報セット
  private setSource = new Subject<any>();
  set$ = this.setSource.asObservable();

  // ナースコール部屋情報削除
  private deleteSource = new Subject<any>();
  delete$ = this.deleteSource.asObservable();

  // ナースコール部屋情報セット
  private getLogSource = new Subject<any>();
  getLogs$ = this.getLogSource.asObservable();


  constructor(
    private _dataCacheService: DataCacheService,
    private _apiNurseCallService: ApiNurseCallService,
    private _apiRoomService: ApiRoomService,
  ) {
  }

  async initLoad() {
    const nursecallRooms = await this._apiNurseCallService.list()
    const rooms = await this._apiRoomService.list()
    let roomsData = { data: rooms.roomList }
    console.log({nursecallRooms});
    this.initSource.next([nursecallRooms, roomsData])
  }

  async load() {
    let res: any = await this._apiNurseCallService.list()
    console.log({ res});
    // if (res.expired) {
    //   data = await this._dataCacheService.set(COOKIES_CONFIG.SENSORS_DATA, res.callRoomList, res.expired)
    // }
    this.loadSource.next(res)
  }

  async loadAsPromise() {
    let res: any = await this._apiNurseCallService.list()
    console.log({ res});
    return res;
  }

  async loadNurseCallRoomList() {
    let res: any = await this._apiNurseCallService.list();
    console.log(res);
    let data = { data: res.data.callRoomList }
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.SENSORS_DATA, res.callRoomList, res.expired)
    }
    this.isInitialized = res.isInitialized;
    this.callRoomListSource.next(data)
  }

  /**
   * 登録
   * @param params
   */
  async create(params): Promise<any> {
    try {
      const res = await this._apiNurseCallService.create(params);
      console.log({res});
      await this.load();
      this.createSource.next(res);
    } catch (e) {
      console.log({e});
      this.createSource.next(Observable.throw(e));
    }
  }

  /**
   * センサー一括登録
   */
  async createAll(paramsList: {
    makerCode: string;
    productCode: string;
    ctlId: string;
    equipId: string;
    callNoCd?: string;
    roomCode: string;
    roomName: string;
    bedNo: string;
    memo?: string;
  }[]): Promise<void> {
    try {
      const results = [];

      for (const params of paramsList) {
        try {
          const res = await this._apiNurseCallService.create(params);
          console.log({res});
          results.push({
            equipId: params.equipId,
            status: 'success',
          });
        } catch (error) {
          results.push({
            equipId: params.equipId,
            status: 'error',
            error,
          });
        }
      }

      await this.load();

      this.createAllSource.next(results);
    } catch (e) {
      console.log({e});
      this.createAllSource.next(Observable.throw(e));
    }
  }


  /**
   * セット
   * @param sensor
   */
  async update(params): Promise<any> {
    try {
      const res = await this._apiNurseCallService.update({ _id: params._id, body: params.body });
      this.setSource.next(res);
      await this.load();
    } catch (e) {
      this.setSource.next(Observable.throw(e));
    }
  }

  /**
   * まるっと更新
   * @param selectedCallRooms
   */
  async updateAll(selectedCallRooms) {
    try {
      const res: any = await this._apiNurseCallService.updateAll({
        body: selectedCallRooms
      })
      this.updateAllSource.next(res);
    } catch (e) {
      this.updateAllSource.next(Observable.throw(e));
    }
  }

  /**
   * 削除
   * @param params
   */
  async delete(params): Promise<any> {
    try {
      const res = await this._apiNurseCallService.delete(params);
      await this.load();
      this.deleteSource.next(res);
    } catch (e) {
      console.log({e});
      this.deleteSource.next(Observable.throw(e));
    }
  }


  // 既存の利用者情報を基準にナースコールとの連携設定状況を確認するもの
  async getOriginalData() {
    return this._apiNurseCallService.getOriginalData();
  }
  async setOriginalData(params) {
    return this._apiNurseCallService.setOriginalData(params);
  }

  // 利用者連携ログを取得する
  async getSyncPatientList(check = false) {
    return this._apiNurseCallService.getSyncPatientList(check);
  }


  async getCallLogs(params = {}) {
    return this._apiNurseCallService.getCallLogs(params);
  }

  async getDiffSyncPatientInfo() {
    return this._apiNurseCallService.getDiffSyncPatientInfo();
  }

}



// WEBPACK FOOTER //
// ./src/providers/nurse-call.service.ts